/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
import moment from 'moment';

async function getAllCourses() {
  const addWeeksToDate = (dateObj, numberOfWeeks) => {
    dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
    return dateObj;
  };
  const substractMonthsToDate = (dateObj, numberOfMonths) => {
    dateObj.setMonth(dateObj.getMonth() - numberOfMonths);
    return dateObj;
  };
  const firstPeriodStart = addWeeksToDate(new Date(), 2).toISOString();
  const firstPeriodEnd = substractMonthsToDate(addWeeksToDate(new Date(), 2), 2).toISOString();
  const secondPeriodStart = substractMonthsToDate(addWeeksToDate(new Date(), 2), 2).toISOString();
  const secondPeriodsEnd = substractMonthsToDate(addWeeksToDate(new Date(), 2), 4).toISOString();
  const thirdPeriodsStart = substractMonthsToDate(addWeeksToDate(new Date(), 2), 4).toISOString();
  const thirdPeriodsEnd = substractMonthsToDate(addWeeksToDate(new Date(), 2), 6).toISOString();
  try {
    const res1 = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?start=${firstPeriodEnd}&end=${firstPeriodStart}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    const res2 = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?start=${secondPeriodsEnd}&end=${secondPeriodStart}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    const res3 = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?start=${thirdPeriodsEnd}&end=${thirdPeriodsStart}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return [...res1.data.result, ...res2.data.result, ...res3.data.result];
  } catch (err) {
    return console.error(err);
  }
}

async function getCoursesByStudentId(studentId) {
  // const end = new Date(coursePlanDates.end).toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?studentId=${studentId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getCoursesByProfessorId(professorId) {
  const start = moment(new Date('2024-01-01')).format('YYYY-MM-DD');
  const now = moment(new Date()).format('YYYY-MM-DD');
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?professorId=${professorId}&dateCreated=${start},${now}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getSchoolData() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/school',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getDailyCourses() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/school/daily-courses/a999kirxhy6lxtt',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getTeacher(email) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/professor/by-email/${email}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getTeacherById(id) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/professor/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getStudent(email) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/student/by-email/${email}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getStudentById(id) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/student/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getStudentPresenceSummary(id, start, end) {
  try {
    const res = await axios({
      method: 'post',
      url: `https://ext.edusign.fr/v1/student/hours-of-presence/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        start: moment(new Date(start)).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(new Date(end)).format('YYYY-MM-DD HH:mm:ss'),
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getJustifiedAbsences(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/justified-absence?page=1&courseId=${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    console.log(res);
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getSignatureLinks(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/get-signature-links/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getTeacherSignatureLink(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/get-professors-signature-links/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function sendSignatureEmails(courseObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/course/send-sign-emails',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        course: courseObj.courseId,
        students: courseObj.students,
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function sendJustifiedAbsence(absenceObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/justified-absence',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        STUDENT_ID: absenceObj.studentId,
        COURSE_ID: absenceObj.courseId,
        TYPE: absenceObj.absenceReason,
        COMMENT: absenceObj.absenceComment,
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function getCourseById(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function exportSummary(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: `https://ext.edusign.fr/v1/course/getGroupAttendanceSheet/${dataObj.groupId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        PROFESSOR_ID: dataObj.professorId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function exportStudentPresenceSummaryDoc(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/document/student/courses-between-dates',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        STUDENT_ID: dataObj.studentId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
        GROUP_ID: '',
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function exportTeacherPresenceSummaryDoc(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/document/professor/courses-between-dates',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        PROFESSOR_ID: dataObj.professorId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
      },
    });
    return res.data.result;
  } catch (err) {
    return console.error(err);
  }
}

async function createSurvey(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/surveys',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        survey: dataObj.surveyTemplateId,
        students: dataObj.students,
        professors: dataObj.professors,
        sending_date: dataObj.sendingDate,
      },
    });
    return res.data;
  } catch (err) {
    return console.error(err);
  }
}

async function getSurveys() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/surveys',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return console.error(err);
  }
}

async function getSurveyById(surveyId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/surveys/${surveyId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return console.error(err);
  }
}

async function lockCourse(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/lock/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return console.error(err);
  }
}

async function unlockCourse(courseId) {
  try {
    const res = await axios({
      method: 'patch',
      url: `https://ext.edusign.fr/v1/course/unlock/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return console.error(err);
  }
}

async function getAbsences() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/justified-absence/absence-reason',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function getCoursesByCourseName(courseName) {
  // const end = new Date(coursePlanDates.end).toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?courseName=${courseName}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

export const edusignServices = {
  getAllCourses,
  getCoursesByStudentId,
  getCoursesByProfessorId,
  getSchoolData,
  getDailyCourses,
  getTeacher,
  getTeacherById,
  getStudent,
  getStudentById,
  getStudentPresenceSummary,
  getSignatureLinks,
  getTeacherSignatureLink,
  sendSignatureEmails,
  sendJustifiedAbsence,
  getCourseById,
  exportSummary,
  exportStudentPresenceSummaryDoc,
  exportTeacherPresenceSummaryDoc,
  createSurvey,
  getSurveys,
  getSurveyById,
  lockCourse,
  unlockCourse,
  getAbsences,
  getCoursesByCourseName,
  getJustifiedAbsences,
};
